module.exports = __webpack_public_path__ + "img/fwts.f2cd98a0.svg";